import { Typography } from "@mui/material";

import { useTT } from "../useTT.ts";

type Props = {
  userFriendlyId: string | undefined;
};
export function UserFriendlyId({ userFriendlyId }: Props) {
  const { tt } = useTT();

  return userFriendlyId ? (
    <Typography variant="body3">
      {tt("dialog.userFriendlyId")}: {userFriendlyId}
    </Typography>
  ) : null;
}
